<div class="p-30">
  <div *ngIf="treatySummary.isNewsExists == false">
    <div *ngFor="let treaty of treatySummary.treatyStatuses">
      <div class="doc-title-one">{{treaty.countryName1}}-{{treaty.countryName2}} {{treaty.title}}</div><br />
      <div class="doc-title-two">Date Signed: {{treaty.signedDate | date:'longDate'}}</div>
      <div class="doc-title-two">Treaty Status: {{treaty.status}}</div><br /><br />

      <div class="doc-title-two">
        Treaty Summary<br /><br />
      </div>
      <particle-dynamic-html [content]="treaty.summaryText"></particle-dynamic-html>
    </div>
  </div>

  <div *ngIf="treatySummary.isNewsExists == true">
    <div *ngFor="let item of treatySummary.newsItems">

      <!--<a ng-click="goToNews(item.NewsItemId,item.CategoryId)"> {{newsItem.NewsHeading}}</a>-->
      <h6 class="title-header m-b-20">{{item.countryHeading}}</h6>
      <div class="fontWeight">
        <span>{{item.newsHeading}}</span>
      </div>
      <particle-dynamic-html [content]="item.newsContent"></particle-dynamic-html>
    </div>
  </div>

</div>
